module.exports = __webpack_public_path__ + "PERUVIANserve-3.12196f9f.png";